import { usePaginatedTable } from './usePaginatedTable';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { SakeBrewersData } from '../types/SakeBrewersData';

type CommonData = SakeBrewersData;

const columnHelper = createColumnHelper<CommonData>();

const columns: ColumnDef<CommonData, any>[] = [
  // columnHelper.accessor('id', {
  //   header: 'id',
  //   cell: info => info.getValue(),
  // }),
  columnHelper.accessor('p_name', {
    header: '都道府県',
    cell: info => info.getValue(),
  }),
  {
    header: '酒蔵名',
    accessorKey: 's_name',
    cell: info => {
      const row = info.row.original;
      const url = row.url;
      const name = row.s_name;
      return url && url !== '-' ? (
        <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
          {name}
        </a>
      ) : (
        <span>{name}</span>
      );
    },
  },
  // columnHelper.accessor('url', {
  //   header: 'URL',
  //   cell: info => {
  //     const url = info.getValue();
  //     return url && url !== '-' ? (
  //       <a href={url} target="_blank" rel="noopener noreferrer">
  //         {url}
  //       </a>
  //     ) : (
  //       <span>-</span>
  //     );
  //   },
  // }),
];

export const useSakeBrewersTable = (
  url: string,
  initialPageIndex = 0,
  pageSize = 10
) => {
  return usePaginatedTable<CommonData>({
    url,
    columns,
    initialPageIndex,
    pageSize,
  });
};
